import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '@mui/material/Card';
// import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';



export default function BasicCard(props) {
  const navigate = useNavigate();
  return (
    // sx={{ minWidth: 275 }}
    <Card key={props.props.key} >
      <CardContent>
        <Typography sx={{ fontSize: 25 }} color="text.secondary" gutterBottom>
          {props.props.cardHeader}
        </Typography>
        {/* <Typography variant="h5" component="div">
          {props.props.iconToDisplay}
        </Typography> */}
        {/* <Typography sx={{ mb: 1.5 }} color="text.secondary">
          adjective
        </Typography> */}
        <Typography variant="body2">
          {props.props.optionsToChoose.map((opt,index) =>{
            return (
              <Grid container spacing={2} key={index}>
                <Grid item xs={12} sm={12} md={12} lg={12}> 
                  <Button 
                    variant='contained' 
                    sx={{mb:'2vh', width:'100%'}}
                    onClick={e=>{
                      navigate(opt.optionLinkTo)
                    }}
                    >
                    <span style={{marginRight:'2vh'}}>{opt.optionIcon} </span>
                    {opt.optionText}</Button>
                </Grid>
              </Grid>
            )
          })}
        </Typography>
      </CardContent>
      {/* <CardActions>
        <Button size="small">Learn More</Button>
      </CardActions> */}
    </Card>
  );
}
